import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Background from 'assets/shared/Gradient_Bg.svg';

import './BannerStep.css';

const useStyles = makeStyles(theme => ({
    banner: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginLeft: '15%',
        [theme.breakpoints.down('lg')]: {
            marginLeft: '1em'
        }
    }
}));

const BannerStep = ({ src, textPrimary, textSecondary, textDescription, step }) => {
    const classes = useStyles();
    return (
        <Box className="login-banner" style={{ backgroundImage: 'url(' + Background + ')' }}>
            <Box classes={classes.banner} className="banner-text-container" marginTop={step === 0 ? '3em' : '3em'}>
                <Box display="flex" flexDirection="column">
                    <Typography variant="bannerTextSecondary">{textSecondary}</Typography>
                    <Typography variant="bannerTextPrimary">{textPrimary}</Typography>
                    <br />
                    <Typography variant="bannerFooterText">{textDescription}</Typography>
                </Box>
            </Box>
            <img className="image-size" src={src} alt="login-banner" draggable="false" height={step === 0 ? '100%' : '70%'} />
        </Box>
    );
};

export default BannerStep;
